import AST from './AST';

const POSITION_ID = 'position';
const TEXT_ARGUMENT_ID = 'text';
const SEARCH_ARGUMENT_ID = 'search';

export default class ASTCompiler {
  constructor(astBuilder) {
    this.astBuilder = astBuilder;
  }

  compile(text) {
    const ast = this.astBuilder.ast(text);
    this.state = { body: [], vars: [], nextId: 0 };
    this.recurse(ast);
    const fnString = `
        let ${POSITION_ID} = 0;
        ${this.state.vars.length ? `let ${this.state.vars.join(',')};` : ''}
        ${this.state.body.join('')}
    `;

    /* eslint-disable-next-line */
    return new Function(TEXT_ARGUMENT_ID, SEARCH_ARGUMENT_ID, fnString);
  }

  recurse(ast) {
    let intoId;

    switch (ast.type) {
      case AST.Program:
        this.state.body.push('return ', this.recurse(ast.body), ';');
        break;
      case AST.UnaryExpression:
        intoId = this.nextId();
        this.state.body.push(
          this.assign(intoId, `${ast.operator}(${this.recurse(ast.argument)})`)
        );
        return intoId;
      case AST.Query:
        intoId = this.nextId();
        this.state.body.push(this.query(intoId, ast.value));
        return intoId;
      case AST.LogicalExpression:
        intoId = this.nextId();
        this.state.body.push(this.assign(intoId, this.recurse(ast.left)));
        this.state.body.push(
          this.if_(
            ast.operator === '&' ? intoId : this.not(intoId),
            this.assign(intoId, this.recurse(ast.right))
          )
        );
        return intoId;
    }
  }

  nextId() {
    const id = `v${this.state.nextId++}`;
    this.state.vars.push(id);
    return id;
  }

  if_(test, consequent) {
    return `
      if (${test}) {
        ${consequent}
      }
    `;
  }

  not(test) {
    return `!(${test})`;
  }

  assign(id, value) {
    return `
      ${id} = ${value};
    `;
  }

  query(id, query) {
    return `
      [${id}, ${POSITION_ID}] = ${SEARCH_ARGUMENT_ID}(${TEXT_ARGUMENT_ID}, "${query}", ${POSITION_ID})
    `;
  }
}
